import { render } from "./navbarComponent.vue?vue&type=template&id=276bd346"
import script from "./navbarComponent.vue?vue&type=script&lang=js"
export * from "./navbarComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__